import { z } from "zod";
import { gql } from "graphql-request";

export const TargetingSchema = z.object({
  townHallLevel: z.array(z.string()).nullable(),
  builderHallLevel: z.array(z.string()).nullable(),
  country: z.array(z.string()).nullable(),
  countryExclude: z.array(z.string()).nullable(),
  platform: z.array(z.string()).nullable(),
  campaignId: z.string().nullable(),
  avatarIds: z.array(z.string()).nullable(),
  hideFromYoungPlayer: z.boolean().nullable(),
});

export const Targeting = TargetingSchema;
export type Targeting = z.infer<typeof TargetingSchema>;

export const TargetingWithoutExcludeSchema = TargetingSchema.omit({
  countryExclude: true,
});

export type TargetingWithoutExclude = z.infer<
  typeof TargetingWithoutExcludeSchema
>;

export const TargetingFragment = gql`
  fragment TargetingFragment on Targeting {
    townHallLevel
    builderHallLevel
    country
    countryExclude
    platform
    campaignId
    avatarIds
    hideFromYoungPlayer
  }
`;
